module.exports = __webpack_public_path__ + "static/media/footsteps.5517bb59.svg";